import { createAsyncThunk } from "@reduxjs/toolkit";
import { customAxios } from "../../../utlis/authService";
import { errorMessage, successMessage } from "../../../utlis/common";
import { SOME_WENT_WRONG } from "../../../utlis/messages";
const LOCATION_ID = process.env.REACT_APP_LOCATION_ID; 
const GET_SHOPIFY_ORDERS = `orders/shopify`

export const FetchShopifyOrders = createAsyncThunk(
  "FetchShopifyOrders",
  async ({ page, limit }: any, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await customAxios('application/json', dispatch).get(`${GET_SHOPIFY_ORDERS}?page=${page}&limit=${limit}&location_id=${LOCATION_ID}`);
      
      if(response?.data?.responseCode && (response?.data?.responseCode != 200)){
        errorMessage(response?.data?.responseMessage || SOME_WENT_WRONG)
      }
      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.responseMessage || SOME_WENT_WRONG)
      return rejectWithValue(error.response.data);
    }
  }
);

export const UpdateOrderStatus = createAsyncThunk(
  "UpdateOrderStatus",
  async ({ id, status }: any, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await customAxios('application/json', dispatch).put(`orders/shopify/status/${id}`, { status });
      successMessage(response.data.responseMessage)
      await dispatch(FetchShopifyOrders({ page: 1, limit:30 }));
      return response.data;
    } catch (error: any) {
      console.log(error,">>> error in update order")
      errorMessage(error?.response?.data?.responseMessage || SOME_WENT_WRONG)

      return rejectWithValue(error.response.data);
    }
  }
);




